import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "data-cy": "core-alarm-logs-report-report-list",
      "fluid": ""
    }
  }, [_vm.showCreateDialog ? _c('core-alarm-logs-report-wizard', {
    attrs: {
      "edit-item": _vm.editingItem,
      "is-open": _vm.showCreateDialog,
      "smart-group-id": _vm.smartGroupId,
      "account-id": _vm.accountId
    },
    on: {
      "close": _vm.closeDialog,
      "submitted": _vm.reloadList
    }
  }) : _vm._e(), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('AlarmLogs.reports.deleteItem.prompt.title'),
      "open": _vm.itemIdToBeDeleted !== null,
      "buttons": [{
        text: _vm.$i18n_t('AlarmLogs.reports.deleteItem.prompt.cancelButton.label'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('AlarmLogs.reports.deleteItem.prompt.deleteButton.label'),
        color: _vm.color,
        emit: 'delete'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.itemIdToBeDeleted = null;
      },
      "delete": _vm.onDeleteItemConfirm
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('AlarmLogs.reports.deleteItem.prompt.text')) + "\n  ")]), _c('core-list-view-page', {
    ref: "alarm-report-list",
    attrs: {
      "fetch-items": _vm.fetchList,
      "fetchErrorMessage": 'AlarmLogs.snacks.fetchLogsFailed',
      "external-fetch-params": {
        accountFilterIsReady: _vm.accountFilterIsReady,
        selectedAccountIds: _vm.selectedAccountIds,
        cacheBuster: _vm.cacheBuster
      },
      "table-headers": _vm.tableHeaders,
      "headline": _vm.$i18n_t('AlarmLogs.reports.header.title'),
      "subtitle": _vm.$i18n_t('AlarmLogs.reports.header.description'),
      "has-search-bar": false,
      "showHeader": _vm.showHeader,
      "empty-state-icon": "fal fa-bell",
      "empty-state-title": _vm.$i18n_t('AlarmLogs.reports.emptyState.title'),
      "empty-state-description": _vm.$i18n_t('AlarmLogs.reports.emptyState.description')
    },
    on: {
      "button:create": function ($event) {
        _vm.showCreateDialog = true;
      },
      "click:empty-state": function ($event) {
        _vm.showCreateDialog = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons-after",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "data-cy": "account-filter",
            "multiple": ""
          },
          on: {
            "change": _vm.accountSelectionChanged,
            "ready": function ($event) {
              _vm.accountFilterIsReady = true;
            }
          }
        })];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };